import { useEffect, useState } from "react";
import { Smartphone, X } from "lucide-react";

export default function DesktopNotice() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem("wv-desktop-dismissed") === "1") return;
    const mq = window.matchMedia("(min-width: 1025px)");
    const update = () => setShow(mq.matches);
    update();
    mq.addEventListener("change", update);
    return () => mq.removeEventListener("change", update);
  }, []);

  if (!show) return null;

  return (
    <div
      data-testid="desktop-notice"
      className="fixed inset-x-0 bottom-0 z-[60] border-t border-gold/30 bg-background/90 backdrop-blur-xl"
    >
      <div className="mx-auto flex max-w-7xl items-center gap-4 px-6 py-3.5">
        <span className="grid h-10 w-10 shrink-0 place-items-center rounded-xl bg-gold/10 text-gold">
          <Smartphone className="h-5 w-5" />
        </span>
        <p className="flex-1 text-sm text-foreground/90">
          <span className="font-semibold text-foreground">Built for phones & tablets.</span>{" "}
          Warranty_Vault pro is a mobile app — desktop use isn't supported yet. You can browse and
          buy/upgrade here, but please use the app on your phone or tablet for the full experience.
        </p>
        <button
          type="button"
          aria-label="Dismiss"
          data-testid="desktop-notice-dismiss"
          onClick={() => {
            sessionStorage.setItem("wv-desktop-dismissed", "1");
            setShow(false);
          }}
          className="grid h-9 w-9 shrink-0 place-items-center rounded-full border border-border text-muted-foreground transition-colors hover:text-foreground"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
